// S&R "View Evaluation" / "Approve Quote" screen (Figma 5524-4473 / 5535-1394).
import { apiCall } from "./apiCall";

export const evaluationApi = {
  // every evaluation draft of the booking ([{ diagnosis_type, diagnosis_data (JSON) }]), e.g. diagnosis_items
  draftAll: (bookingId) => apiCall("get", "bookings/diagnosis/draft/all", { booking_id: bookingId }, { silent: true }),

  // unit form config (questions + options) for a system / product / heat type; the Select Unit list reads tonnage etc. from it
  unitConfig: (params) => apiCall("get", "units-new/config", params, { silent: true }),

  // G-18 read-only quote: { is_approved, items[{ heading, data[] }], sub_total, total_discount, total, total_text }.
  // Approved → the consumer's set, else the technician's. Never summary/calculate: it rewrites the draft.
  quote: (bookingId, opts) => apiCall("get", "bookings/diagnosis/summary/quote", { booking_id: bookingId }, opts),

  // G-70: the quote JSON the app draws its PDF from — summary/quote plus `parts` on every item (helpers/quotePdf)
  quotePdfData: (bookingId) => apiCall("get", "bookings/diagnosis/summary/quote/pdf", { booking_id: bookingId }, { silent: true }),
  // G-70: email the PDF the app drew (multipart { booking_id, email, file }), new quote-email format
  sendQuotePdf: (bookingId, email, file) => {
    const fd = new FormData();
    fd.append("booking_id", bookingId);
    fd.append("email", email);
    fd.append("file", file);
    return apiCall("post", "bookings/diagnosis/summary/quote/pdf/send", fd);
  },

  // Equipment Diagnosis list for a unit: { indoor: { body[] }, outdoor: { body[] } }; values already include the
  // carried-over (re-evaluated) items, everything else the default
  equipmentList: (bookingId, unitId) => apiCall("get", "bookings/diagnosis/revamp/options", { booking_id: bookingId, unit_id: unitId }),
  // diagnosis draft (per booking, not per unit), same call as the Vuex storeChecks
  saveDraft: (bookingId, type, data) => apiCall("post", "bookings/diagnosis/draft/store", {
    booking_id: bookingId, diagnosis_type: type, diagnosis_data: JSON.stringify(data),
  }),
};
